'use client'
import React from 'react';
import styled from 'styled-components';
import ReactHtmlParser from "react-html-parser";
import {title} from "@/styles/globalStyleVars";

const Title = ({
                   text,
                   fontSize,
                   fontWeight,
                   color,
                   letterSpacing,
                   lineHeight,
                   textTransform,
                   margin,
                   padding,
                   borderColor,
                   varient,
                   center,
                   classname,
                   marginSm,
                   width
               }) => {


    return (

        <StyledTitle className={`subtitle ${classname}`}
                     fontSize={fontSize}
                     fontWeight={fontWeight}
                     color={color}
                     lineHeight={lineHeight}
                     LetterSpacing={letterSpacing}
                     textTransform={textTransform}
                     margin={margin}
                     padding={padding}
                     varient={varient}
                     center={center}
                     marginSm={marginSm}
                     width={width}
                     borderColor={borderColor}>
            <h3 className={''}>{ReactHtmlParser(text)} </h3>


        </StyledTitle>

    )
};


const StyledTitle = styled.div`
  margin: ${props => props.margin || '0px'};
  position: relative;
  width: ${props => props.width || 'fit-content'};
  font-family: ${title};
  text-align: ${props => props?.center ? 'center' : ''};
  padding: ${p => p.padding};

  h3 {
    font-size: ${props => props.fontSize || 24}px;
    line-height: ${props => props.lineHeight || 32}px;
    //text-transform: uppercase;
    font-weight: ${props => props.fontWeight || '800'};
    color: ${props => props.color || "#3C3C3B"};
      margin-bottom: 30px;
  }
    
    @media(min-width: 1920px){
        h3{
            font-size: 28px;
            line-height: 36px;
        }
    }


  @media (max-width: 767px) {
    padding: 0;
    margin: ${p => p.marginSm};
    h3 {
      font-size: 20px ;
      line-height: 28px;
    }
  }
`;


export default Title;














